// import moment from 'moment-timezone';

// const maintenanceDate = moment().add(1, 'd').toISOString();
// const messageTriggerDate = moment().add(30, 's').toISOString();

export default class FakeMaintenanceService {
  get() {
    return Promise.resolve(null);
    // return Promise.resolve({
    //   fo: {
    //     id: 1,
    //     'maintenance-date': maintenanceDate,
    //     'message-trigger-date': messageTriggerDate,
    //     message: '<span>This is a maintenance message</span>',
    //     'message-fr': '<span>Ceci est un message de maintenance</span>',
    //     'message-de': '<span>[This is a maintenance message]</span>'
    //   }
    // });
  }
}
